import { useGetOrganizationsApi } from '@/hooks/api/organizations/use-organizations-api';
import { useSelectedOrganization } from '@/hooks/utils/use-selected-organization';
import { useEffect, useMemo } from 'react';

const ADMIN_ORGANIZATION_NAME = 'admin';

export function useAnalyticsAccess() {
  const { data: organizations = [], isLoading } = useGetOrganizationsApi();
  const { selectedOrganization, setSelectedOrganization } = useSelectedOrganization();
  const defaultOrganizationName = useMemo(
    () =>
      organizations.find(
        org =>
          org.organizationName.toLowerCase() !== ADMIN_ORGANIZATION_NAME &&
          org.permissions.includes('viewAnalytics'),
      )?.organizationName,
    [organizations],
  );

  useEffect(() => {
    if (isLoading || selectedOrganization || !defaultOrganizationName) return;
    setSelectedOrganization(defaultOrganizationName);
  }, [defaultOrganizationName, isLoading, selectedOrganization, setSelectedOrganization]);

  const canViewAnalytics = useMemo(() => {
    const currentOrganizationName =
      selectedOrganization.split(',')[0]?.trim() || defaultOrganizationName;
    if (!currentOrganizationName) return false;
    if (currentOrganizationName.toLowerCase() === ADMIN_ORGANIZATION_NAME) return false;
    const currentOrganization = organizations.find(
      org => org.organizationName === currentOrganizationName,
    );
    return currentOrganization?.permissions.includes('viewAnalytics') ?? false;
  }, [defaultOrganizationName, organizations, selectedOrganization]);

  const analyticsAccessLoading = isLoading || (!!defaultOrganizationName && !selectedOrganization);

  return {
    canViewAnalytics,
    analyticsAccessLoading,
  };
}
